<template>
  <div class="admiddions-normal-list" :class="{ no_border: noBorder }">
    <div class="list_title" >
      <div class="title_box">
        <img src="@/assets/images/gift.png" class="list_title_img" />
        <div class="list_title_text">招生信息</div>
      </div>
    </div>
    <ul class="content-box">
      <li v-for="(item, index) in listData" :key="index"  v-if="index <3">
        <a
          :href="item.titleurl ? item.titleurl : `${context}/frontend/showNews.html?hashcode=${item.hashcode}`"
          target="_blank"
          :class="{ isRed: item.redtitle == '是' }"
          @mouseover="f(item.title)" @mouseleave="h()"
        >
          <div class="news_info">
            <div class="news_time">
               <p class="news_month">{{item.publishTime|getMoth}}</p>
               <p class="news_day">{{item.publishTime|getDay}}</p>
            </div>
            <div class="news_info_right">
                <div class="news_address">
                  <img src="@/assets/images/address.png" class="news_img" />
                  <span class="news_title">{{item.title}}</span>
                </div>
                <div class="news_user">
                  <img src="@/assets/images/user.png" class="news_img" />
                  {{item.publisher}}
                </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <p class="more"><a :href="getHref(menu)">+more</a></p>
  </div>
</template>

<script>
import { getHref } from '@/utils';
export default {
  props: ['listData','menu'],
  filters: {
    getDay: function(value) {
      let time = value.split('-');
      return time[2];
    },
    getMoth: function(value) {
      let time = value.split('-');
      return time[0] + '.' + time[1];
    }
  },
  methods: {
    getHref,
    //添加鼠标跟随事件，动态显示完整标题（首页），通过动态生成div实现
    f(str){
        let full=document.getElementById("fullTitleShow")
        if(full==null){
            full=document.createElement('div');
            full.id="fullTitleShow"
            full.innerHTML=str
            full.style.position="absolute"
            full.style.left=window.event.pageX+"px"
            full.style.top=window.event.pageY+"px"
            full.style.backgroundColor="white"
            full.style.padding="10px"
            full.style.border="1px solid black"
            full.style.zIndex=10000
            document.body.appendChild(full);
        }
    },
    h(){
        let full=document.getElementById("fullTitleShow")
        if(full!=null){
            document.body.removeChild(full)
        }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
.admiddions-normal-list{
  .list_title {
    height: 36px;
    margin:12px 12px 0;
    border-bottom: 2px solid #ccc;
    position: relative;
    display: flex;
    flex-direction: row;
    .title_box {
      height: 36px;
      border-bottom: 2px solid  $theme_color;
      display: flex;
      flex-direction: row;
      align-items: center;
      .list_title_text {
        color: #d81e06;
        font-size: 16px;
        font-weight: 600;
        margin-right:6px;
      }
      .list_title_img{
        width: 16px;
        height: 16px;
        margin:0 6px;
      }
    }
  }
  ul {
    list-style-type: none;
    padding: 12px 10px 0;
    li {
      margin-top: 12px;
      a {
        .news_title {
          @include overLine(2);
          font-size: 14px;
          &:before {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 6px;
            margin-right: 5px;
            /* margin-top: -5px; */
            content: '';
            background: #333;
            transform: scale(0.8);
          }
          &:hover {
            color: #cd0200;
          }
        }
        .news_info {
          display: flex;
          flex-direction: row;
          margin-top:12px;
          .news_time{
            width: 60px;
            height: 70px;
            margin-left: 8px;
            border:1px solid #ccc;
            .news_month{
               width: 60px;
               height: 24px;
               background-color: $theme_color;
               color: #fff;
               font-size: 12px;
               line-height: 24px;
               text-align: center;
            }
            .news_day{
              width: 60px;
              height: 56px;
              font-size: 30px;
              color:#555;
              line-height: 56px;
              text-align: center
            }
          }
          .news_info_right{
            flex: 1;
            font-size: 14px;
            line-height: 24px;
            .news_img{
              width: 16px;
              height: 16px;
              margin: 0 12px;
            }
            .news_address{
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 50px;
              &:hover {
                color: #cd0200;
              }
            }
          }
        }
      }
    }
  }
  
  .more {
    margin-top: 27px;
    text-align: right;
    font-size: 14px;
    margin-right: 10px;
    a {
      color: $text_theme_color !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admissions/index.vue